var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[(_vm.registerType === 'cash')?_c('cash-register-top-bar'):_vm._e(),(
      _vm.registerType === 'panel' ||
      _vm.registerType === 'ai-caffe-wide' ||
      _vm.registerType === 'bottom-up' ||
      _vm.registerType === 'ai-crud' ||
      _vm.registerType === 'ai-compact' ||
      _vm.registerType === 'ai-shop'
    )?_c('panel-register-top-bar'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }